import { render, staticRenderFns } from "./logincode.vue?vue&type=template&id=f0d4f1ba"
import script from "./logincode.vue?vue&type=script&lang=js"
export * from "./logincode.vue?vue&type=script&lang=js"
import style0 from "./logincode.vue?vue&type=style&index=0&id=f0d4f1ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports